import { deLocalizeUrl } from '@paraglide/runtime'

export const reroute = (request: { url: string | URL }): string => {
	return deLocalizeUrl(request.url).pathname
}
